
import { defineComponent, SetupContext, ref, PropType } from "vue";
import NativeClient from "@/client/native-client";
import PantryCameraRadioItem from "./PantryCameraRadioItem.vue";
import {
  PantryCameraDateData,
} from "@/types/pantry";

export default defineComponent({
  name: "PantryCameraDateDialog",
  components: {
    PantryCameraRadioItem
  },
  props: {
    roomId: {
      type: Number,
      default: -1
    },
    areaId: {
      type: Number,
      default: -1
    },
    selectId: {
      type: Number,
      default: -1
    },
    dateList: {
      type: Array as PropType<PantryCameraDateData[]>,
      default: []
    }
  },
  setup(props, context: SetupContext) {
    const nowId = ref(props.selectId);
    const selectChecked = (id: number) => {
      nowId.value = id;
      NativeClient.sendDebugLog("PantryCameraDateDialog selectChecked id=" + id);
      context.emit("select-date", props.roomId, props.areaId, id);
    };
    return {
      nowId,
      selectChecked
    };
  }
});
